import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import DropdownButton from '../../core/DropdownButton';
import Search from './Search';
import DEFAULT_FILTER from './defaultFilter';
/**
 * @param {import('./types').DataFilterProps} props
 */

var DataFilter = function DataFilter(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      children = _ref.children,
      hideSearch = _ref.hideSearch,
      variant = _ref.variant,
      collapseIfSingle = _ref.collapseIfSingle,
      showArrowIcon = _ref.showArrowIcon,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "options", "children", "hideSearch", "variant", "collapseIfSingle", "showArrowIcon"]);

  var canFilter = options || children;
  var canSearch = !hideSearch;
  return React.createElement(Grid, Object.assign({
    container: true,
    alignItems: "center"
  }, rest), canFilter && React.createElement(Grid, {
    item: true
  }, React.createElement(DropdownButton, {
    onClick: onChange.filter,
    options: options,
    hoverable: "background",
    label: value.label,
    labelPlacement: "start",
    labelVariant: variant,
    showArrowIcon: showArrowIcon,
    collapseIfSingle: collapseIfSingle
  }, children)), canSearch && React.createElement(Grid, {
    item: true
  }, React.createElement(Search, {
    defaultFilter: value.searchIn,
    defaultValue: value.searchValue,
    onChange: onChange.search,
    variant: variant
  })));
};

DataFilter.defaultProps = {
  value: DEFAULT_FILTER,
  hideSearch: false,
  collapseIfSingle: false,
  showArrowIcon: true
};
export default DataFilter;